<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-12 mb-primary">
				<div class="card card-with-shadow border-0 h-100">
					<div class="card-header p-primary bg-transparent">
						<h5 class="card-title m-0">Inquiry Form</h5>
					</div>
					<app-overlay-loader v-if="preloader" />
					<div class="card-body">
						<form
							ref="form"
							data-url="/inquiry-settings"
							class="mb-0"
							:class="{ 'loading-opacity': preloader }"
						>
							<div class="row">
								<!-- Inquiry Banner -->
								<div class="col-md-6">
									<div class="form-group default-file">
										<label> Inquiry Banner </label>
										<app-input
											type="file"
											:label="'Upload Banner'"
											v-model="inputs.inquiry_form_banner"
										/>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<small class="text-muted font-italic">
											<ul>
												<li>
													File type: JPG, PNG
												</li>
												<li>File size: 2MB</li>
												<li>Dimension: 1837 x 300</li>
												<!-- <li>Dimension: 1920 x 1080</li> -->
											</ul>
										</small>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6">
									<!-- Description -->
									<div class="form-group row align-items-center">
										<label for="inputs_inquiry_form_description" class="col-sm-3 mb-0">
											Description
										</label>
										<app-input
											id="inputs_inquiry_form_description"
											class="col-sm-9"
											type="textarea"
											v-model="inputs.inquiry_form_description"
											:placeholder="'Description'"
											:textAreaRows="5"
											:textAreaCols="5"
										/>
									</div>
								</div>
							</div>

							<div class="mt-5 action-buttons">
								<button
									type="submit"
									class="btn btn-primary mr-2"
									@click.prevent="submit"
								>
									{{ $t("submit") }}
								</button>
								<button
									type="submit"
									class="btn btn-secondary"
									@click.prevent="clear"
								>
									{{ $t("clear") }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

export default {
	name: "InquirySettings",
	mixins: [FormMixin],
	data() {
		return {
			preloader: false,
			inputs: {
				inquiry_form_banner: null,
				inquiry_form_description: null,
			},
		};
	},
	created() {
		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [inquirySettingsResponse] =
					await Promise.all([
						axios.get("/inquiry-settings"),
					]);

				// set this.inputs
				this.inputs.inquiry_form_description =
					inquirySettingsResponse.data.inquiry_form_description;
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		beforeSubmit() {
			this.preloader = true;
		},
		submit() {
			if (!(this.inputs.inquiry_form_banner instanceof File) && this.inputs.inquiry_form_description == null) {
				this.$toastr.e("Inquiry Banner is required");
				return;
			}
			if (this.inputs.inquiry_form_banner == null) {
				delete this.inputs.inquiry_form_banner;
			}
			this.save(this.inputs);
		},

		afterSuccess(res) {
			this.$toastr.s(res.data.message);
		},
		afterFinalResponse() {
			this.preloader = false;
		},
		afterError(res) {
			this.$toastr.e(res.data.message);
		},
		clear() {
			this.fieldStatus = {
				isSubmit: false,
			};
		},
	},
};
</script>

<style scoped>
.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
